import { render, staticRenderFns } from "./FAQJobseekers.vue?vue&type=template&id=b6f59524&scoped=true&"
import script from "./FAQJobseekers.vue?vue&type=script&lang=js&"
export * from "./FAQJobseekers.vue?vue&type=script&lang=js&"
import style0 from "./FAQJobseekers.vue?vue&type=style&index=0&id=b6f59524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f59524",
  null
  
)

export default component.exports